// Constants.js
// A file just for constants to be used elsewhere.
import {
  enumLanguage,
  kDivisionID,
  kEmployeeID,
  kNameID,
  kPhotoID,
  kPositionDivisionID,
  kPositionID,
  kPositionTitleID,
  kTitleID
} from "@coreapp/constants";

export const MainDisplayFieldIds = {
  name: "Name",
  id: "PersonID",
  title: "Title",
  dept: "Division",
  photo: "Photo"
};

export const PositionHoldersDisplayFieldIds = {
  name: kNameID,
  id: kEmployeeID,
  title: kTitleID,
  dept: kDivisionID,
  photo: kPhotoID
};

export const PositionMainDisplayFieldNames = {
  name: kPositionTitleID,
  id: kPositionID,
  dept: kPositionDivisionID
};

export const ContactDisplayFieldIds = {
  phone: "Phone",
  location: "Location",
  email: "Email"
};

export const AllowedLevels = [2, 3, 4, 5];

// TODO enumChartTypes already exists
export const ChartTypes = {
  Standard: "Standard",
  Inverted: "Inverted",
  Level: "Level"
};
export const AllChartTypes = [ChartTypes.Standard, ChartTypes.Inverted, ChartTypes.Level];

export const ImportTypes = {
  import: "import",
  append: "append",
  merge: "merge",
  photo: "photo"
};

// Date Handling
import { es, fr, de, enUS } from "date-fns/locale";
export const LANGUAGE_TO_DATE_LOCALE = {
  [enumLanguage.english]: enUS,
  [enumLanguage.spanish]: es,
  [enumLanguage.french]: fr,
  [enumLanguage.german]: de
};

//view library
export const VIEW_LIBRARY_OPT_PREFIX = "view-library-opt";

export const PLACEHOLDER_TABLE_VALUE = "--";

// Table constants
export const TABLE_SELECTED_ROW_STYLE = Object.freeze({
  background: "#fcf5ed",
  color: "#3D3D4A",
  fontWeight: "500",
  cursor: "pointer",
  border: "#ed9e49"
});

export const upgradeCardStyle = { background: "var(--bg-brand-secondary)" };
